import React from 'react';
import styled from 'styled-components';
import { Button, Input } from 'components';

const ImportLockboxKdps: React.FC<{
  fire: (payload: any) => Promise<void>;
}> = ({ fire }) => {
  const [orgId, setOrgId] = React.useState('');
  const [allOrgs, setAllOrgs] = React.useState(false);

  const handleFire = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    fire({ orgId, allOrgs });
  };

  return (
    <StyledForm onSubmit={handleFire}>
      <Button htmlType="submit">Fire</Button>
    </StyledForm>
  );
};

const StyledInput = styled(Input)`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 0.5fr 3fr;
  input {
    display: inline;
  }
`;
const StyledForm = styled.form`
  width: 750px;
  display: grid;
  grid-gap: 15px;
`;

export default ImportLockboxKdps;
